import '@/styles/index.css';
import '@/theme/variables';

import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ToastContainer } from 'component-library';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';

import { navigationService } from '@/config/navigationService';
import { queryClient } from '@/config/queryClient';
import { router } from '@/router';

navigationService.setNavigate((to) => router.navigate(to));

function App() {
  return (
    <>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          {import.meta.env.SHOW_REACT_QUERY_DEVTOOLS && <ReactQueryDevtools initialIsOpen={false} />}
          <RouterProvider router={router} />
        </QueryClientProvider>
      </HelmetProvider>
      <ToastContainer />
    </>
  );
}

// eslint-disable-next-line import/no-default-export
export default App;
